module.exports = __webpack_public_path__ + "img/end.f86397ee.png";